import React, { useState, useEffect } from 'react';
import './Main.css';
import PhotoGallery from './PhotoGallery'; // Import the gallery component


const Main = ({ currentPage }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    // Load content from HTML files based on currentPage
    const loadContent = async () => {
      try {
        let htmlContent = '';
        
        switch (currentPage) {
          case 'welcome':
            // For a real implementation, we would fetch the HTML file here
            // But in React, we need to handle this differently since we can't use fetch for local files directly
            // Instead, we'll use the content directly from the file
            htmlContent = `
              <div class="page-content">
                <div style="position: relative; width: 100%;">
                  <img src="/images/Welcome1.png" alt="Willkommen bei unserer Physiotherapie" style="width: 100%; height: auto; display: block;" />
                  <div style="position: absolute; bottom: 100px; left: 20px; color: #1064a9ff ; padding: 10px 15px; border-radius: 5px;">
                    <h2>Willkommen in Ihrer Physiotherapie Praxis</h2>
                  </div>
                  <div style="position: absolute; bottom: 20px; left: 40px;">
                    <button style="background-color: #4CAF50; color: white; padding: 12px 24px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;">
                      Praxistermin vereinbaren
                    </button>
                  </div>
                </div>
                <div style="background-color: #78BEC1; padding: 20px; text-align: center;">
                  <h1>Wir helfen Ihnen dabei, Ihre Gesundheit zu stärken</h1>
                </div>
                <div style="padding: 20px; text-align: center;"><h2>Ihre Physiotherapiepraxis in Peine</h2></div>
               
                <div style="display: flex; gap: 20px;">
                  <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
                    <img src="/images/Welcome2.png" alt="Praxis Image" style="width: 100%; height: auto;" />
                  </div>
                  <div style="flex: 2; text-align: left;">
                    <p>Wir freuen uns, dass Sie den Weg zu uns gefunden haben. In unserer interdisziplinären Praxis in Peine arbeiten wir gemeinsam daran, Ihre Gesundheit zu stärken. Unserer Mitarbeiter verfügen über langjährige Erfahrungen in den unterschiedlichen Fachdisziplinen. Durch zahlreiche externe Fort- und Weiterbildungen ist das Team fachlich immer auf dem neuesten Stand und verfügt über vielfältige Zusatzqualifikationen.Mithilfe moderner und effizienter Diagnoesverfahren und Behandlungsmethoden erarbeiten wir für jeden Patienten einen individuellen Therapieplan, der eine optimale Versorung garantiert. Unser Ziel ist es, gemeinsam mit ihnen den bestmöglichen Therapieerfolg zu erzeilen. Wir als interdisziplinäres Team arbeiten Hand in Hand, um Ihnen eine gnazheitliche, individuelle Versorgung zu bieten.<p>Wenden Sie sich bei Fragen einfach an uns - Wir freuen uns darauf, Ihnen weiter zu helfen!<p>Ihr Team der Praxis Mutke</p>
                  </div>
                </div>

                <div style="width: 100%">
                  <div>
                    <h2><strong>Was unsere Frachübergreifende Praxis auszeichnet</strong></h2>
                    <p>
                    Eine Entscheidung für unsere Praxis ist eine Entscheidung dafür, Ihre Gesundheit zu stärken. Erfahren Sie im Folgendem, was unsere Stammkunden an uns schätzen.
                  </div>
                  <table>                                 
                      <tr>
                          <td>
                              <img src="/images/Welcome_Fachpraxis.png" alt="Interdisziplinäre Fachpraxis" style="height: 150px">
                          </td>
                          <td>
                              <img src="/images/Welcome_Parkplatz.png" alt="Parkplätze vor der Praxis" style="height: 150px">
                          </td>
                          <td>
                              <img src="/images/Welcome_Hausbesuche.png" alt="Hausbesuche" style="height: 150px">
                          </td>
                          
                      </tr>
                      <tr>
                          <td align="center" style="padding: 20px; background-color: #f9f9f9; border-radius: 8px;">
                              <strong>
                                  Interdisziplinäre Fachpraxis
                              </strong><p>
                              Wir vereinen unterschiedliche Anwendungsbereiche der Physiotherapie in derselben Praxis. So können Sie gemeinsam Ihre Therapien im selben Gebäude wahrnehmen.
                          </td>
                          <td align="center" style="padding: 20px; background-color: #f9f9f9; border-radius: 8px;">
                              <strong>
                                  Parkplätze vor der Praxis
                              </strong><p>
                              Wir sind problemlos mit dem ÖPNV und dem eigenen Fahrzeug zu erreichbar. Parken Sie vor unserer Praxis und nutzen Sie unseren barrierefreien Zugang.
                          </td>
                          <td align="center" style="padding: 20px; background-color: #f9f9f9; border-radius: 8px;">
                              <strong>
                                  Hausbesuche
                              </strong><p>
                              Wir sind flexibel und besuchen Sie auch gerne zur Therapie bei Ihnen zu Hause. Profitieren Sie von unseren persönlichen hausbesuchen in Ihrer vertrauten Umgebung.
                          </td>
                      </tr>                
                  </table>
                </div>
                <br />
                <p />
                <div style="width: 100%">
                  <div>
                     Auf unserer Website haben Sie nicht nur die Möglichkeit, mehr über unserer Therapiemöglichkeiten zu erfahren. Hier stellen wir Ihnen auch unsere Praxis und unser Team vor.
                  </div>
                  <br />
                  <table style="width: 100%">                                 
                      <tr>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Physiotherapie.png" alt="zur Physiotherapie" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>zur Physiotherapie</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Team.png" alt="zum Team" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>zum Team</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Galerie.png" alt="zur Galerie" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>zur Galerie</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Kontakt.png" alt="zum Kontakt" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>zum Kontakt</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <td align="center">
                              <strong>
                                  Physiotherapie
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Team
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Galerie
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Kontakt
                              </strong><p>
                              
                          </td>
                      </tr>                
                  </table>
                </div>
                <div style="background-color: #78BEC1; text-align: left; display: flex">
                  <div>
                    <img src="/images/Welcome_Telephone.png" style="width: 200px; padding: 20px; align-self: flex-start;"/>
                  </div>
                  <div>
                    <div style="padding: 20px;">   
                      Wir sind gerne für Sie da.
                    </div>
                    <div style="padding: 20px;">
                      <button style="background-color: #4CAF50; color: white; padding: 20px 40px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;">
                        Praxistermin vereinbaren
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            `;
            break;
          case 'physiotherapie':
            htmlContent = `
              <div class="page-content">
                <div style="position: relative; width: 100%;">
                  <img src="/images/Welcome1.png" alt="Willkommen bei unserer Physiotherapie" style="width: 100%; height: auto; display: block;" />
                  <div style="position: absolute; bottom: 100px; left: 20px; color: #1064a9ff ; padding: 10px 15px; border-radius: 5px;">
                    <h2>Unsere Physiotherapie</h2>
                  </div>
                  <div style="position: absolute; bottom: 20px; left: 40px;">
                    <button style="background-color: #4CAF50; color: white; padding: 12px 24px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;">
                      Praxistermin vereinbaren
                    </button>
                  </div>
                </div>
                <div style="background-color: #78BEC1; padding: 20px; text-align: center;">
                  <h1>Behandlung durch professionelle Physiotherapeuten</h1>
                </div>
                <div style="padding: 20px; text-align: center;"><h2>Physiotherapie in Peine</h2></div>
               
                <div style="display: flex; gap: 20px;">
                  <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
                    <img src="/images/Welcome2.png" alt="Praxis Image" style="width: 100%; height: auto;" />
                  </div>
                  <div style="flex: 2; text-align: left;">
                    <p>Unsere Physiotherapie ist darauf ausgerichtet, Ihre Gesundheit und Beweglichkeit zu fördern. Wir bieten individuelle Behandlungspläne basierend auf Ihren spezifischen Bedürfnissen. Unsere erfahrenen Therapeuten verwenden moderne Techniken und Methoden zur Diagnose und Behandlung von verschiedenen Erkrankungen und Verletzungen.</p>
                    <p>Mit Hilfe moderner Diagnoseverfahren und effizienter Behandlungsmethoden erarbeiten wir für jeden Patienten einen individuellen Therapieplan, der eine optimale Versorgung garantiert. Unser Ziel ist es, gemeinsam mit Ihnen den bestmöglichen Therapieerfolg zu erzielen. Wir als interdisziplinäres Team arbeiten Hand in Hand, um Ihnen eine ganzheitliche, individuelle Versorgung zu bieten.</p>
                    <p>Wenden Sie sich bei Fragen einfach an uns - Wir freuen uns darauf, Ihnen weiter zu helfen!<p>Ihr Team der Praxis Mutke</p>
                  </div>
                </div>
                <p>&nbsp;</p>
                <div style="width: 100%">
                  <div>
                    <h2><strong>Unsere Physiotherapie-Angebote</strong></h2>
                    <p>
                    Wir bieten eine breite Palette an physiotherapeutischen Behandlungen an, um Ihre individuellen Bedürfnisse optimal zu erfüllen.
                  </div>
                </div>  
                <div style="width: 100%">
                  <div>
                     Unsere Praxis bietet moderne physiotherapeutische Behandlungen für alle Altersgruppen. Hier erfahren Sie mehr über unsere verschiedenen Therapieansätze.
                  </div>
                  <br />
                  <table style="width: 100%">                                 
                      <tr>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Physiotherapie.png" alt="KG (Krankengymnastik)" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Gezielte Übungen zur Verbesserung von Beweglichkeit, Kraft, Koordination und Funktion des Körpers.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Team.png" alt="KG-ZNS PNF" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Spezielle neurophysiologische Therapie zur Förderung von Bewegungsabläufen und Muskelaktivität bei neurologischen Erkrankungen.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Kontakt.png" alt="MT (Manuelle Therapie)" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Behandlung von Gelenk-, Muskel- und Nervenfunktionsstörungen durch gezielte Handgriffe und Mobilisationstechniken.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Kontakt.png" alt="MLD (Manuelle Lymphdrainage)" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Sanfte Behandlungstechnik zur Anregung des Lymphflusses und Reduzierung von Schwellungen.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Team.png" alt="Massage" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Lockerung verspannter Muskulatur sowie Förderung der Durchblutung und Entspannung.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <td align="center">
                              <strong>
                                  KG (Krankengymnastik)
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  KG-ZNS PNF
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  MT (Manuelle Therapie)
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  MLD (Manuelle Lymphdrainage)
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Massage
                              </strong><p>
                              
                          </td>
                      </tr> 
                      <tr>
                        <td colspan="5" class="center">
                          <h2><strong>Zusätzliche Leistungen</strong></h2>
                        </td>
                      </tr>
                      <tr>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Physiotherapie.png" alt="Ultraschall-Therapie" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Anwendung von Schallwellen zur Unterstützung der Heilung und Linderung von Schmerzen in Gewebe und Muskulatur.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Kontakt.png" alt="Fango" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Wärmeanwendung mit Naturmoor zur Schmerzlinderung und Entspannung von Muskeln und Gelenken.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Kontakt.png" alt="Heißluft" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Tiefenwärmebehandlung zur Durchblutungsförderung und Vorbereitung auf die weitere Therapie.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                          <td>
                              <div class="flip-container">
                                <div class="flip-card">
                                  <div class="flip-card-front">
                                    <img src="/images/Welcome_Physiotherapie.png" alt="Tapen" style="width: 200px">
                                  </div>
                                  <div class="flip-card-back">
                                    <p>Elastische oder stabilisierende Tape-Anlagen zur Unterstützung von Muskeln, Gelenken und Bewegungsabläufen.</p>
                                  </div>
                                </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <td align="center">
                              <strong>
                                  Ultraschall-Therapie
                              </strong><p>
                              
                          </td>

                          <td align="center">
                              <strong>
                                  Fango
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Heißluft
                              </strong><p>
                              
                          </td>
                          <td align="center">
                              <strong>
                                  Tapen
                              </strong><p>
                              
                          </td>
                      </tr> 
                      
                  </table>
                </div>
                <p>&nbsp;</p>
                <div style="background-color: #78BEC1; text-align: left; display: flex">
                  <div>
                    <img src="/images/Welcome_Telephone.png" style="width: 200px; padding: 20px; align-self: flex-start;"/>
                  </div>
                  <div>
                    <div style="padding: 20px;">   
                      Wir sind gerne für Sie da.
                    </div>
                    <div style="padding: 20px;">
                      <button style="background-color: #4CAF50; color: white; padding: 20px 40px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;">
                        Praxistermin vereinbaren
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            `;
            break;
          case 'ueber-uns':
            htmlContent = `
              <div class="page-content">
                <h1>Über uns</h1>
                  <!-- Gallery section placeholder -->
                  <div id="gallery-section-placeholder" style="margin: 40px 0; text-align: center;">
                    <h2 style="color: #2e7d32;">Unsere Praxis in Bildern</h2>
                    <p>Bilder unserer modernen Praxisräume und Einrichtungen</p>
                  </div>             
                </div>
              </div>
            `;
            break;
          case 'kontakt':
            htmlContent = `
              <div class="page-content">
                <h1>Kontakt</h1>
                <p>Kontaktinformationen und Anfahrt.</p>
                
                <div style="max-width: 600px; margin: 20px auto; padding: 20px; background-color: #f9f9f9; border-radius: 8px;">
                  <h2>Terminvereinbarung</h2>
                  <p>Füllen Sie bitte das folgende Formular aus, um einen Termin zu vereinbaren. Wir werden uns umgehend bei Ihnen melden.</p>
                  
                  <form id="appointmentForm" style="display: flex; flex-direction: column; gap: 15px;">
                    <div>
                      <label for="name" style="display: block; margin-bottom: 5px; font-weight: bold;">Vor- und Nachname:</label>
                      <input type="text" id="name" name="name" required style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
                    </div>
                    
                    <div>
                      <label for="email" style="display: block; margin-bottom: 5px; font-weight: bold;">E-Mail-Adresse:</label>
                      <input type="email" id="email" name="email" required style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
                    </div>
                    
                    <div>
                      <label for="phone" style="display: block; margin-bottom: 5px; font-weight: bold;">Telefonnummer:</label>
                      <input type="tel" id="phone" name="phone" required style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
                    </div>
                                 
                    
                    <div>
                      <label for="treatment" style="display: block; margin-bottom: 5px; font-weight: bold;">Behandlungsgrund:</label>
                      <select id="treatment" name="treatment" required style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
                        <option value="">Bitte wählen Sie einen Behandlungsgrund</option>
                        <option value="Rückenschmerzen">Rückenschmerzen</option>
                        <option value="Kopfschmerzen">Kopfschmerzen</option>
                        <option value="Sportverletzung">Sportverletzung</option>
                        <option value="Arthrose">Arthrose</option>
                        <option value="Neurologische Erkrankung">Neurologische Erkrankung</option>
                        <option value="Atemwegserkrankung">Atemwegserkrankung</option>
                        <option value="Sonstiges">Sonstiges</option>
                      </select>
                    </div>
                    
                    <div>
                      <label for="message" style="display: block; margin-bottom: 5px; font-weight: bold;">Zusätzliche Informationen:</label>
                      <textarea id="message" name="message" rows="4" style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;"></textarea>
                    </div>
                    
                    <div>
                      <button type="submit" style="background-color: #4CAF50; color: white; padding: 12px 24px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px; width: 100%;" disabled>
                        Diese Funktion wird momentan überarbeitet
                      </button>
                    </div>
                  </form>
                </div>
                
                <div style="margin-top: 30px;">
                  <h2>Kontaktdaten</h2>
                  <p><strong>Adresse:</strong> Kantstrasse 40, 31224 Peine</p>
                  <p><strong>Telefon:</strong> +49 5171 588512</p>
                  <p><strong>E-Mail:</strong> info@praxis-mutke.de</p>
                  
                  <h4>Öffnungszeiten</h4>
                  <table align="center" style="margin: 0 auto;">
                    <tr>
                      <td style="text-align: left;">
                        Mo, Di, Do:<br/>
                        &nbsp;
                      </td>
                      <td style="text-align: right;">
                        08:00 - 12:00<br/>
                        15:00 - 18:00
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">
                        Mi - Fr:<br/>
                        &nbsp;
                      </td>
                      <td style="text-align: right;">
                        08:00 - 12:00<br/>
                        ab 12 Uhr nach Vereinbarung
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">
                        Sa, So:
                      </td>
                      <td style="text-align: right;">
                        Geschlossen
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            `;         
            break;
          default:
            // Default to welcome page
            htmlContent = `
              <div class="page-content">
                <div style="position: relative; width: 100%;">
                  <img src="/images/Welcome1.png" alt="Willkommen bei unserer Physiotherapie" style="width: 100%; height: auto; display: block;" />
                  <div style="position: absolute; bottom: 20px; left: 20px; background-color: rgba(0, 0, 0, 0.5); color: white; padding: 10px 15px; border-radius: 5px;">
                    <h2>Willkommen in Ihrer Physiotherapie Praxis</h2>
                  </div>
                  <div style="position: absolute; bottom: 20px; right: 20px;">
                    <button style="background-color: #4CAF50; color: white; padding: 12px 24px; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;">
                      Praxistermin vereinbaren
                    </button>
                  </div>
                </div>
                <div style="background-color: #add8e6; padding: 20px; text-align: center;">
                  <h1>Wir helfen Ihnen dabei, Ihre Gesundheit zu stärken</h1>
                </div>
                <p>Hier finden Sie Informationen über unsere Behandlungen und Dienstleistungen.</p>
                <div class="content-placeholder">
                  <p>Willkommen auf unserer Willkommensseite! Wir freuen uns, Sie bei uns begrüßen zu dürfen.</p>
                  <p>Unsere Physiotherapie-Praxis bietet modernste Behandlungsmethoden für eine schnelle und effektive Rehabilitation.</p>
                </div>
              </div>
            `;
        }
        
        setContent(htmlContent);
      } catch (error) {
        console.error('Error loading content:', error);
        setContent('<div class="error">Fehler beim Laden des Inhalts</div>');
      }
    };

    loadContent();
  }, [currentPage]);

  return (
    <main className="main">
      <div dangerouslySetInnerHTML={{ __html: content }} />
      {/* Conditionally render gallery for welcome page */}
      {currentPage === 'ueber-uns' && (
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}>
          <PhotoGallery />
        </div>
      )}
    </main>
  );
};

export default Main;
